// import https from 'https';
import axios from 'axios';
import { isEmpty } from 'lodash';
import Firechat from './Firechat';

const url_nootificar = 'https://owlichat.superlogica.com/notificar';
const url_set_token = 'https://owlichat.superlogica.com/settoken';

export default class NotificationsManager {

    static init({user, subscriptionChange}){

        if( isEmpty(user) )
            throw Error("Usuário deve ser informado")

        const _chat = Firechat.getInstance(user.licenca);

        var OneSignal = window.OneSignal || [];
        console.log("init notifications")
        OneSignal.push(() => {
            OneSignal.init({
                appId: "c6d4c66c-3ec5-429f-8dfe-8ab9ba4ab3a1",
                allowLocalhostAsSecureOrigin: true
            });

            OneSignal.on('subscriptionChange', isSubscribed => {
                if (isSubscribed) {
                    OneSignal.getUserId(userIdToken => {
                        _chat.updateUser("tokenPush", userIdToken, err => console.log("ERRO", err));
                        NotificationsManager.setTokenPlayer(userIdToken, user.id, user.email, user.licenca)
                            .then(res => {
                                console.log("Salvou", res)
                            })
                            .catch((err) => {
                                // Se deu erro tem qeu tratar, pois nesse ponto já salvou no Onesignal
                                console.log(err);
                            })
                    });
                }
                subscriptionChange&&subscriptionChange();
            });

            // Garantir que o token mais recente vai estar salvo nos dados do usuário do chat
            OneSignal.getUserId( userIdToken => {
                if( userIdToken )
                    _chat.updateUser("tokenPush", userIdToken, err => console.log("ERRO", err));
            });

        });
    }

    static showPromptPermission(){
        var OneSignal = window.OneSignal || [];
        OneSignal.push(function() {
            OneSignal.showHttpPrompt({force: true});
        });
    }

    static getStatusPermission(){
        
        var OneSignal = window.OneSignal || [];
        return new Promise((resolve, reject) => {
            if( !("Notification" in window) ) resolve("not suported");

            const status = window.Notification.permission;
            
            if( status === "denied"){
                resolve("denied");
            }
            else if( status === "granted" ) {
                OneSignal.push(["isPushNotificationsEnabled", res => {
                    console.log("isPushEnable", res)
                    resolve(res === true ? "granted" : "default");
                }]);
            }
            else {
                resolve("default"); 
            }
        })
    }

	static sendNotification(message, user){

		// se tiver online ou não tiver token não notifica
		if(user.isOnline === true || user.tokenPush === null) return true;

		axios.post(url_nootificar, { message, token: user.tokenPush })
		.then(response=> {
			console.log("SUCCESS", response);
		})
		.catch(error=> {
			console.log("ERROR", error);
        });		
    }
        
    static setTokenPlayer(token=null, iduser=null, email=null, licenca=null, tipo="web"){

        if( !token || !iduser || !email || !licenca ) return false;

        console.log("WEB PUSH TOKEN SAVE=>")

        return axios.post(url_set_token, { token, iduser, email, licenca, tipo })
            .then(response=> {
                console.log("SUCCESS", response);
                return response
            })
            .catch(error=> {
                console.log("ERROR", error);
                return error
            });
    }
	
}


// WEBPACK FOOTER //
// ./src/utils/NotificationsManager.js